<form *ngIf="noteFormGroup" [formGroup]="noteFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="notes">Notas</label>
            <textarea pInputTextarea formControlName="notes" style="field-sizing: content;"
                d-form-field-error></textarea>
        </div>
        <div class="col-3 input-field" *ngIf="!asociatedTask?.id">
            <label for="generateTask">Generar tarea</label>
            <p-inputSwitch id="generateTask" [ngModelOptions]="{standalone: true}"
                [(ngModel)]=" generateTask"></p-inputSwitch>
        </div>
        <div class="col-4 input-field" *ngIf="generateTask && !asociatedTask?.id">
            <label for="selectedUser">Asignar a</label>
            <p-dropdown id="selectedUser" [options]="users" optionLabel="name" optionValue="id" appendTo="body"
                [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedUser" showClear [filter]="true"
                filterBy="name"></p-dropdown>
        </div>
        <div class="col-5 input-field"  *ngIf="generateTask && !asociatedTask?.id">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" formControlName="date" [monthNavigator]="true"
                dateFormat="dd/mm/yy" [showTime]="true" [hourFormat]="'24'" d-form-field-error appendTo="body"></p-calendar>
        </div>
        <div class="col-12" style="cursor: pointer" *ngIf="asociatedTask?.id" (click)="goToTask(asociatedTask)">
            <p-messages [value]="[{
                    severity: 'info',
                    detail: 'Existe una tarea asociada asignada al usuario ' + getUserName(asociatedTask.userId) + '. Pulse aquí para ver la tarea asociada'
                    }]" [closable]="false" />
        </div>
    </div>
    <div class="mt-4 flex justify-content-between">
        <p-button label="Eliminar" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"
            *ngIf="note.id && allowDelete"></p-button>
        <div class="flex gap-2">
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </div>
</form>